// extracted by mini-css-extract-plugin
export default {"contentClassName":"HubTagTemplatesModal_contentClassName__Tj1IR"};